<div class="page-container" *ngIf="reportData">
  <div class="top-bar">
    <div class="left" (click)="goBack()" style="cursor: pointer">
      <i class="bi bi-arrow-left"></i>
      Back
    </div>
    <div class="right">
      <button class="btn-primary" (click)="copyLink()">
        <i class="bi bi-share"></i> Share Report
      </button>
    </div>
  </div>

  <div class="content-wrapper">
    <div class="report-card">
      <div class="top-section-enhanced">
        <div class="score-circle">
          <div
            class="circle"
            [ngClass]="getScoreClass(performance.score_percentage)"
            [style.background]="getCircleProgress(performance.score_percentage)"
          >
            <div class="inner">
              <h2 [ngClass]="getScoreClass(performance.score_percentage)">
                {{ performance.score_percentage || "0%" }}
              </h2>
              <span>{{
                reportData.status === "submitted"
                  ? (reportData.status | titlecase)
                  : ("Incomplete" | uppercase)
              }}</span>
            </div>
          </div>
        </div>

        <div class="info-section-enhanced">
          <div class="info-header">
            <span
              class="badge"
              [ngClass]="{
                'badge-pass': reportData.result?.toLowerCase() === 'passed',
                'badge-fail': reportData.result?.toLowerCase() === 'failed',
                'badge-incomplete': reportData.status === 'in progress',
              }"
            >
              <i
                class="bi bi-check-circle-fill"
                *ngIf="reportData.result === 'passed'"
              ></i>
              <i
                class="bi bi-x-circle-fill"
                *ngIf="
                  reportData.result === 'failed' ||
                  reportData.status === 'in progress'
                "
              ></i>
              {{
                reportData.status === "in progress"
                  ? "Incomplete"
                  : (reportData.result | titlecase)
              }}
            </span>
            <h2 class="title">
              {{ reportData.quiz_name
              }}<span *ngIf="reportData.link_name || linkName">
                - {{ reportData.link_name || linkName }}</span
              >
            </h2>
            <p class="meta">
              <i class="bi bi-person-fill"></i> {{ reportData.student_name }}
              <span class="dot-separator">•</span>
              <ng-container
                *ngIf="
                  reportData.student_email ||
                  reportData.candidate_email ||
                  reportData.email
                "
              >
                <i class="bi bi-envelope-fill"></i>
                {{
                  reportData.student_email ||
                    reportData.candidate_email ||
                    reportData.email
                }}
                <span class="dot-separator">•</span>
              </ng-container>
              <i class="bi bi-calendar-event"></i>
              {{
                reportData.status === "submitted" ? "Submitted" : "Incomplete"
              }}

              {{
                reportData.status === "submitted"
                  ? (reportData.finished_at | date: "mediumDate")
                  : ""
              }}
            </p>
          </div>

          <div class="stats-enhanced">
            <div class="stat-box-new">
              <div class="sb-header">
                <i class="bi bi-award-fill score-icon-new"></i>
                <p>SCORE</p>
              </div>
              <h3>
                {{
                  reportData.status === "submitted"
                    ? performance.gained_points + "/" + performance.total_marks
                    : "0"
                }}
              </h3>
            </div>
            <div class="stat-box-new">
              <div class="sb-header">
                <i class="bi bi-check-circle-fill correct-icon-new"></i>
                <p>CORRECT</p>
              </div>
              <h3 class="green">
                {{ performance.total_number_of_correct_answer }}
              </h3>
            </div>
            <div class="stat-box-new">
              <div class="sb-header">
                <i class="bi bi-x-circle-fill incorrect-icon-new"></i>
                <p>INCORRECT</p>
              </div>
              <h3 class="red">
                {{ performance.total_number_of_incorrect_answer }}
              </h3>
            </div>
            <div class="stat-box-new">
              <div class="sb-header">
                <i class="bi bi-dash-circle-fill unanswered-icon-new"></i>
                <p>UNANSWERED</p>
              </div>
              <h3>{{ performance.total_number_of_skipped_answer }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="proctor-card-enhanced" *ngIf="is_proctored !== false">
      <div class="proctor-header-enhanced">
        <div class="ph-left">
          <div class="ph-icon">
            <i class="bi bi-shield-lock-fill"></i>
          </div>
          <div class="ph-text">
            <h3>Proctoring Report</h3>
            <p>Activity recorded during this assessment</p>
          </div>
        </div>
        <div class="ph-right">
          <span class="event-badge-total"
            >Total Violations: <strong>{{ totalViolations }}</strong></span
          >
          <span class="event-badge-warning"
            >Warning : <strong>{{ warningViolationsCount }}</strong></span
          >
          <span class="event-badge-critical"
            >Critical : <strong>{{ criticalViolationsCount }}</strong></span
          >
        </div>
      </div>

      <div class="proctor-grid-enhanced">
        <!-- MULTIPLE FACES -->
        <div
          class="proctor-box-new"
          [class.highlight]="violations['MULTIPLE_FACES']"
        >
          <div class="pb-top">
            <div class="pb-title-area">
              <div class="pb-icon-round red"><i class="bi bi-people"></i></div>
              <div class="pb-title-text">
                <h4>Multiple Faces</h4>
                <span>Violation issues</span>
              </div>
            </div>
            <span
              class="pb-badge warning"
              *ngIf="
                violations['MULTIPLE_FACES'] && violations['MULTIPLE_FACES'] > 0
              "
              >WARNING</span
            >
          </div>
          <div class="pb-bottom">
            <div class="pb-occ">
              <p>OCCURRENCES</p>
              <h3>{{ violations["MULTIPLE_FACES"] ?? 0 }}</h3>
            </div>
          </div>
        </div>

        <!-- LOOKING AWAY -->
        <div
          class="proctor-box-new"
          [class.highlight]="violations['LOOKING_AWAY']"
        >
          <div class="pb-top">
            <div class="pb-title-area">
              <div class="pb-icon-round red">
                <i class="bi bi-eye-slash"></i>
              </div>
              <div class="pb-title-text">
                <h4>Looking Away</h4>
                <span>Violation issues</span>
              </div>
            </div>
            <span
              class="pb-badge warning"
              *ngIf="
                violations['LOOKING_AWAY'] && violations['LOOKING_AWAY'] > 0
              "
              >WARNING</span
            >
          </div>
          <div class="pb-bottom">
            <div class="pb-occ">
              <p>OCCURRENCES</p>
              <h3>{{ violations["LOOKING_AWAY"] ?? 0 }}</h3>
            </div>
          </div>
        </div>

        <!-- FACE TOO FAR -->
        <div
          class="proctor-box-new"
          [class.highlight]="violations['FACE_TOO_FAR']"
        >
          <div class="pb-top">
            <div class="pb-title-area">
              <div class="pb-icon-round orange">
                <i class="bi bi-person-bounding-box"></i>
              </div>
              <div class="pb-title-text">
                <h4>Face Too Far</h4>
                <span>Violation issues</span>
              </div>
            </div>
            <span
              class="pb-badge warning"
              *ngIf="
                violations['FACE_TOO_FAR'] && violations['FACE_TOO_FAR'] > 0
              "
              >WARNING</span
            >
          </div>
          <div class="pb-bottom">
            <div class="pb-occ">
              <p>OCCURRENCES</p>
              <h3>{{ violations["FACE_TOO_FAR"] ?? 0 }}</h3>
            </div>
          </div>
        </div>

        <!-- TAB SWITCH -->
        <div
          class="proctor-box-new"
          [class.highlight]="violations['TAB_SWITCH']"
        >
          <div class="pb-top">
            <div class="pb-title-area">
              <div class="pb-icon-round red">
                <i class="bi bi-window-stack"></i>
              </div>
              <div class="pb-title-text">
                <h4>Tab Switch</h4>
                <span>Violation issues</span>
              </div>
            </div>
            <span
              class="pb-badge critical"
              *ngIf="violations['TAB_SWITCH'] && violations['TAB_SWITCH'] > 0"
              >CRITICAL</span
            >
          </div>
          <div class="pb-bottom">
            <div class="pb-occ">
              <p>OCCURRENCES</p>
              <h3>{{ violations["TAB_SWITCH"] ?? 0 }}</h3>
            </div>
          </div>
        </div>

        <!-- NO FACE -->
        <div class="proctor-box-new" [class.highlight]="violations['NO_FACE']">
          <div class="pb-top">
            <div class="pb-title-area">
              <div class="pb-icon-round red">
                <i class="bi bi-person-x"></i>
              </div>
              <div class="pb-title-text">
                <h4>No Face</h4>
                <span>Violation issues</span>
              </div>
            </div>
            <span
              class="pb-badge warning"
              *ngIf="violations['NO_FACE'] && violations['NO_FACE'] > 0"
              >WARNING</span
            >
          </div>
          <div class="pb-bottom">
            <div class="pb-occ">
              <p>OCCURRENCES</p>
              <h3>{{ violations["NO_FACE"] ?? 0 }}</h3>
            </div>
          </div>
        </div>

        <!-- EYES CLOSED -->
        <div
          class="proctor-box-new"
          [class.highlight]="violations['EYES_CLOSED']"
        >
          <div class="pb-top">
            <div class="pb-title-area">
              <div class="pb-icon-round orange"><i class="bi bi-eye"></i></div>
              <div class="pb-title-text">
                <h4>Eyes Closed</h4>
                <span>Violation issues</span>
              </div>
            </div>
            <span
              class="pb-badge warning"
              *ngIf="violations['EYES_CLOSED'] && violations['EYES_CLOSED'] > 0"
              >WARNING</span
            >
          </div>
          <div class="pb-bottom">
            <div class="pb-occ">
              <p>OCCURRENCES</p>
              <h3>{{ violations["EYES_CLOSED"] ?? 0 }}</h3>
            </div>
          </div>
        </div>

        <!-- BACKGROUND VOICE -->
        <div
          class="proctor-box-new"
          [class.highlight]="violations['BACKGROUND_VOICE']"
        >
          <div class="pb-top">
            <div class="pb-title-area">
              <div class="pb-icon-round orange"><i class="bi bi-mic"></i></div>
              <div class="pb-title-text">
                <h4>Background Voice</h4>
                <span>Violation issues</span>
              </div>
            </div>
            <span
              class="pb-badge warning"
              *ngIf="
                violations['BACKGROUND_VOICE'] &&
                violations['BACKGROUND_VOICE'] > 0
              "
              >WARNING</span
            >
          </div>
          <div class="pb-bottom">
            <div class="pb-occ">
              <p>OCCURRENCES</p>
              <h3>{{ violations["BACKGROUND_VOICE"] ?? 0 }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="recording-wrapper" *ngIf="is_proctored !== false">
      <div class="recording-container-enhanced">
        <div class="recording-header-enhanced" (click)="toggleSection()">
          <div class="rh-left">
            <div class="rh-icon">
              <i class="bi bi-camera-video-fill"></i>
            </div>
            <div class="rh-text">
              <h2>Recording & Snapshots</h2>
              <p>Camera evidence captured during the session</p>
            </div>
          </div>
          <span class="arrow" [class.rotate]="isOpen">
            <i class="bi toggle-icon bi-chevron-down"></i>
          </span>
        </div>

        <div class="recod"></div>

        <div class="content" [class.open]="isOpen">
          <div class="snapshot-section">
            <h4 class="mb-3">CAPTURED SNAPSHOTS</h4>

            <div
              class="snapshot-grid"
              *ngIf="
                reportData.snapshots && reportData.snapshots.length > 0;
                else noSnapshots
              "
            >
              <div
                class="snapshot-card"
                *ngFor="let item of reportData.snapshots"
                (click)="openSnapshotPreview(item.s3_url)"
                style="cursor: pointer"
              >
                <span
                  class="pb-badge critical"
                  style="position: absolute; top: 10px; left: 10px; z-index: 10"
                  *ngIf="['TAB_SWITCH'].includes(item.violation_type)"
                >
                  CRITICAL
                </span>
                <span
                  class="pb-badge warning"
                  style="position: absolute; top: 10px; left: 10px; z-index: 10"
                  *ngIf="
                    [
                      'FACE_TOO_FAR',
                      'EYES_CLOSED',
                      'BACKGROUND_VOICE',
                      'NO_FACE',
                      'MULTIPLE_FACES',
                      'LOOKING_AWAY',
                    ].includes(item.violation_type)
                  "
                >
                  WARNING
                </span>

                <div class="tag" style="left: auto; right: 10px; z-index: 10">
                  {{ item.violation_type.replaceAll("_", " ") }}
                </div>

                <img [src]="item.s3_url" />

                <div class="card-content">
                  <p class="title">
                    {{ item.violation_type.replaceAll("_", " ") }}
                  </p>
                  <span> {{ getRelativeTime(item.timestamp) }}</span>
                </div>
              </div>
            </div>
            <ng-template #noSnapshots>
              <div class="empty-state">
                <i class="bi bi-camera"></i>
                <p>No snapshots available</p>
              </div>
            </ng-template>
          </div>

          <div class="recording-section">
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 12px;
              "
            >
              <h4 class="m-3">SESSION RECORDING</h4>
              <a
                *ngIf="reportData?.recording_url"
                href="javascript:void(0)"
                class="btn-primary-outline"
                (click)="downloadRecording($event, reportData.recording_url)"
                style="
                  padding: 8px 16px;
                  border-radius: 8px;
                  text-decoration: none;
                  border: 1px solid #e5e7eb;
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  font-weight: 500;
                  font-size: 14px;
                  color: #374151;
                  background: white;
                  transition: background 0.2s;
                "
                onmouseover="this.style.background = '#f9fafb'"
                onmouseout="this.style.background = 'white'"
              >
                <i class="bi bi-download"></i> Download Video
              </a>
            </div>

            <div
              *ngIf="reportData.recording_url; else noRecording"
              class="video-box"
            >
              <div class="video-container-v4">
                <div
                  class="video-preview-overlay-v4"
                  *ngIf="reportData.recording_url"
                  (click)="openVideoLightbox()"
                >
                  <div class="play-btn-v4">
                    <i class="bi bi-play-fill"></i>
                  </div>
                  <span>Click to view recording</span>
                </div>
                <video
                  [src]="safeRecordingUrl"
                  *ngIf="reportData.recording_url"
                  class="preview-video-v4"
                ></video>
                <div
                  class="video-placeholder-v4"
                  *ngIf="!reportData.recording_url"
                >
                  <i class="bi bi-play-circle"></i>
                  <p>Session Recording Unavailable</p>
                </div>
              </div>
            </div>
            <ng-template #noRecording>
              <div class="empty-state">
                <i class="bi bi-camera-video-off"></i>
                <p>No recording available</p>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div class="answer-review-card">
      <div class="header" (click)="toggleAnswerSection()">
        <div>
          <h3>Answer Review</h3>
          <p class="subtitle">
            Question-by-question breakdown of the candidate's submission.
          </p>
        </div>
        <span class="arrow" [class.rotate]="isAnswerOpen">
          <i class="bi bi-chevron-down"></i>
        </span>
      </div>
      <div class="content" [class.open]="isAnswerOpen">
        <div
          *ngFor="let conv of conversations; let i = index"
          class="question-item-enhanced"
        >
          <!-- Left status icon -->
          <div
            class="qi-status-icon"
            [ngClass]="
              getAnswerStatusClass(getEvaluation(conv).answer_type) + '-icon-bg'
            "
          >
            <i
              *ngIf="getEvaluation(conv).answer_type === 'correct'"
              class="bi bi-check-circle"
            ></i>
            <i
              *ngIf="getEvaluation(conv).answer_type === 'incorrect'"
              class="bi bi-x-circle"
            ></i>
            <i
              *ngIf="
                getEvaluation(conv).answer_type !== 'correct' &&
                getEvaluation(conv).answer_type !== 'incorrect'
              "
              class="bi bi-dash-circle"
            ></i>
          </div>

          <div class="qi-content">
            <div class="question-header-enhanced">
              <span class="q-number">Question {{ i + 1 }}</span>
              <span
                class="status-outline"
                [ngClass]="
                  getAnswerStatusClass(getEvaluation(conv).answer_type) +
                  '-outline'
                "
              >
                {{
                  getEvaluation(conv).answer_type === "attempted"
                    ? "Attempted"
                    : (getEvaluation(conv).answer_type | titlecase)
                }}
              </span>
              <span class="marks">{{ conv.questions.marks }} mark</span>
            </div>

            <h4 class="question-text-enhanced">
              <ng-container
                *ngIf="
                  $any(conv.questions).question_blocks?.length;
                  else plainQuestion
                "
              >
                <app-question-blocks
                  [blocks]="$any(conv.questions).question_blocks"
                  [content]="conv.questions.question_text"
                  [diagrams]="
                    isManualDiagram($any(conv.questions))
                      ? []
                      : $any(conv.questions).diagrams || []
                  "
                >
                </app-question-blocks>
              </ng-container>
              <ng-template #plainQuestion>
                {{ conv.questions.question_text || "No question available" }}
              </ng-template>
              <div
                *ngIf="isManualDiagram($any(conv.questions))"
                class="question-diagram-wrapper"
              >
                <img
                  [src]="$any(conv.questions).diagram_url"
                  alt="Question diagram"
                  class="question-diagram"
                />
              </div>
            </h4>

            <ng-container
              *ngIf="
                conv.questions.question_type === 'MCQ' ||
                conv.questions.question_type === 'TRUE_FALSE'
              "
            >
              <div
                *ngFor="let opt of conv.questions.options"
                [ngClass]="getOptionClass(conv, opt.text)"
                class="option-enhanced"
              >
                <div class="option-content-enhanced">
                  <div class="opt-left">
                    <i
                      *ngIf="
                        conv.user_answer === opt.text &&
                        getEvaluation(conv).answer_type === 'incorrect'
                      "
                      class="bi bi-x-circle wrong-color"
                    ></i>
                    <i
                      *ngIf="getEvaluation(conv).correct_answer === opt.text"
                      class="bi bi-check-circle correct-color"
                    ></i>
                    <span
                      class="text"
                      [ngClass]="{
                        'correct-text':
                          getEvaluation(conv).correct_answer === opt.text,
                        'wrong-text':
                          conv.user_answer === opt.text &&
                          getEvaluation(conv).answer_type === 'incorrect',
                      }"
                    >
                      <ng-container
                        *ngIf="$any(opt).blocks?.length; else plainOption"
                      >
                        <app-question-blocks
                          [blocks]="$any(opt).blocks"
                          [content]="opt.text"
                          [diagrams]="[]"
                        >
                        </app-question-blocks>
                      </ng-container>
                      <ng-template #plainOption>
                        {{ opt.text || "No option available" }}
                      </ng-template>
                      <img
                        *ngIf="
                          $any(opt).image_url &&
                          (!$any(opt).blocks || $any(opt).blocks.length === 0)
                        "
                        [src]="$any(opt).image_url"
                        [alt]="opt.text || 'option image'"
                        class="option-diagram"
                      />
                    </span>
                  </div>

                  <div class="opt-right labels-outline">
                    <span
                      class="tag-outline correct-outline"
                      *ngIf="getEvaluation(conv).correct_answer === opt.text"
                    >
                      CORRECT
                    </span>
                    <span
                      class="tag-outline selected-outline"
                      *ngIf="conv.user_answer === opt.text"
                    >
                      SELECTED
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="conv.questions.question_type === 'OPEN_ENDED'">
              <div class="open-ended-answer">
                <p>
                  <strong>Your Answer:</strong>
                  {{ conv.user_answer ?? "No answer provided" }}
                </p>
                <p>
                  <strong>Expected:</strong>
                  {{ getEvaluation(conv).correct_answer }}
                </p>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!reportData" class="loading-state">
  <p>Loading report...</p>
</div>

<div
  class="snapshot-preview-modal"
  *ngIf="previewSnapshotUrl"
  (click)="closeSnapshotPreview()"
>
  <button class="close-btn" (click)="closeSnapshotPreview()">
    <i class="bi bi-x-lg"></i>
  </button>
  <div class="snapshot-preview-container" (click)="$event.stopPropagation()">
    <img [src]="previewSnapshotUrl" alt="Snapshot Preview" />
  </div>
</div>

<!-- Video Lightbox (Premium Player) -->
<div
  class="video-lightbox-v4"
  *ngIf="selectedVideo"
  (click)="closeVideoLightbox()"
>
  <div
    class="video-player-modal-v4"
    (click)="$event.stopPropagation()"
    #videoContainer
  >
    <button class="btn-close-player-v4" (click)="closeVideoLightbox()">
      <i class="bi bi-x-lg"></i>
    </button>

    <div class="player-content-v4">
      <video
        #lightboxVideo
        [src]="selectedVideo"
        (timeupdate)="onTimeUpdate($event)"
        (loadedmetadata)="onLoadedMetadata($event)"
        (play)="isPlaying = true"
        (pause)="isPlaying = false"
        (ended)="isPlaying = false"
        autoplay
      ></video>

      <!-- Center Play Overlay (visible on pause) -->
      <div
        class="player-center-play-v4"
        *ngIf="!isPlaying"
        (click)="togglePlay()"
      >
        <i class="bi bi-play-fill"></i>
      </div>

      <!-- Player Controls -->
      <div class="player-controls-v4" (click)="$event.stopPropagation()">
        <!-- Progress Bar -->
        <div class="player-progress-v4">
          <input
            type="range"
            class="seek-slider-v4"
            [value]="currentTime"
            [max]="duration"
            step="0.1"
            (input)="onSeekPreview($event)"
            (change)="onSeekEnd($event)"
            [style.background-size]="
              (currentTime / (duration || 1)) * 100 + '% 100%'
            "
          />
        </div>

        <div class="player-bottom-row-v4">
          <div class="controls-left-v4">
            <button
              class="ctrl-btn-v4"
              (click)="skip(-10)"
              title="Backward 10s"
            >
              <i class="bi bi-arrow-counterclockwise"></i>
            </button>
            <button class="ctrl-btn-v4 main-play-v4" (click)="togglePlay()">
              <i
                class="bi"
                [ngClass]="isPlaying ? 'bi-pause-fill' : 'bi-play-fill'"
              ></i>
            </button>
            <button class="ctrl-btn-v4" (click)="skip(10)" title="Forward 10s">
              <i class="bi bi-arrow-clockwise"></i>
            </button>
            <div class="time-display-v4">
              <span>{{ formatTime(currentTime) }}</span>
              <span class="time-sep">/</span>
              <span>{{ formatTime(duration) }}</span>
            </div>
          </div>

          <div class="controls-right-v4">
            <div class="volume-control-v4">
              <button class="ctrl-btn-v4" (click)="toggleMute()">
                <i
                  class="bi"
                  [ngClass]="
                    isMuted || volume === 0
                      ? 'bi-volume-mute-fill'
                      : 'bi-volume-up-fill'
                  "
                ></i>
              </button>
              <input
                type="range"
                class="volume-slider-v4"
                [value]="volume"
                min="0"
                max="1"
                step="0.05"
                (input)="onVolumeChange($event)"
                [style.background-size]="volume * 100 + '% 100%'"
              />
            </div>
            <button
              class="ctrl-btn-v4"
              (click)="toggleFullscreen()"
              title="Full Screen"
            >
              <i class="bi bi-fullscreen"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
